// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-child-malnutrition label.no-style {
  padding: 0;
  font-size: 16px;
  position: relative;
}
.upload-prescription input[type="file"] {
  display: inline-block;
  font-size: 0;
}
.patient-details span.text-muted{
  text-transform: capitalize;
}
.patient-details span.text-muted span{
  /* max-width: 115px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: auto; */
    font-weight: 600;
}
.health-chart a svg{
  width:16px;
  /* fill: #af1e25; */
}

.charts{
  position: absolute;
  top: 65px;
  right: -20px;
  font-size: 14px;
  font-weight: 500;
  transform: rotate(90deg);
  width:65px;
  display: flex;
}

.charts svg{
  width:16px;
  /* fill: #af1e25; */
  margin-right: 6px;
}

.button-box .charts a{
  padding: 0;
}
.d-text{
  font-style: italic;
  font-size: 12px;
}
.btn:hover{
  background-color: transparent;
}
.btn:active{
  background-color: transparent;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/childmalnutrition/ChildMalnutrition.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;;;kBAIgB;IACd,gBAAgB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX","sourcesContent":[".create-child-malnutrition label.no-style {\r\n  padding: 0;\r\n  font-size: 16px;\r\n  position: relative;\r\n}\r\n.upload-prescription input[type=\"file\"] {\r\n  display: inline-block;\r\n  font-size: 0;\r\n}\r\n.patient-details span.text-muted{\r\n  text-transform: capitalize;\r\n}\r\n.patient-details span.text-muted span{\r\n  /* max-width: 115px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: auto; */\r\n    font-weight: 600;\r\n}\r\n.health-chart a svg{\r\n  width:16px;\r\n  /* fill: #af1e25; */\r\n}\r\n\r\n.charts{\r\n  position: absolute;\r\n  top: 65px;\r\n  right: -20px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transform: rotate(90deg);\r\n  width:65px;\r\n  display: flex;\r\n}\r\n\r\n.charts svg{\r\n  width:16px;\r\n  /* fill: #af1e25; */\r\n  margin-right: 6px;\r\n}\r\n\r\n.button-box .charts a{\r\n  padding: 0;\r\n}\r\n.d-text{\r\n  font-style: italic;\r\n  font-size: 12px;\r\n}\r\n.btn:hover{\r\n  background-color: transparent;\r\n}\r\n.btn:active{\r\n  background-color: transparent;\r\n  border: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
